export const PAGE_SIZE_OPTIONS = {
  DEFAULT: [10, 25, 50, 100],
  TEST: [1, 2, 10, 25, 50, 100]
};
